import React from "react";
import { useController } from "react-hook-form";

const Input = ({ name, control, rules = {}, disabled = false, defaultValue = '', ...props }) => {
    const { field, fieldState: { error } } = useController({
        name,
        control,
        defaultValue,
        rules,
        disabled
    });

    return <>
        <input
            className='admin_modal_label'
            {...field}
            {...props}
        />
        {error?.message && <p className="form_error_txt">{error?.message}</p>}
    </>
};

export default Input;